import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function createProject(data) {
    return HttpService.post('/v1/projects', data);
}

export async function updateProject(data) {
    const { id } = data;
    delete data.id;
    return HttpService.put('/v1/projects/' + id, data);
}

export async function removeProject(id) {
    return new Promise((resolve) => resolve(id));
}

export async function loadProjects() {
    return HttpService.get('/v1/projects');
}

export async function loadProject(projectId) {
    return HttpService.get('/v1/projects/' + projectId);
}
